// extracted by mini-css-extract-plugin
export default {"wrapper__sidebar":"Soundbar_wrapper__sidebar__HTyNJ"};